<template>
  <v-snackbar
    v-model="usePaymentLinkNotificationStore().isVisible"
    color="success"
    location="top right"
  >
    <v-card-text align="center">
      <span class="text-h6" align="center"> {{ $t("common.notification.paymentReceived") }}! </span>

      <p
        style="color: grey"
        v-dateWithTime="usePaymentLinkNotificationStore().selectedPayment?.created"
      />
      <span
        style="color: black"
        v-money="{
          amount: usePaymentLinkNotificationStore().selectedPayment?.amount,
        }"
      />
      <span style="color: grey" class="pl-2">
        {{ usePaymentLinkNotificationStore().selectedPayment?.currency?.toUpperCase() }}
      </span>
    </v-card-text>
  </v-snackbar>
</template>
<script lang="ts" setup>
import { usePaymentLinkNotificationStore } from "@/payment-links/stores/paymentLinkNotification";
</script>
